import React from "react";

// Components
import AuthenticationLayout from "~/layouts/AuthenticationLayout";

// Assetes
import LoginForm from "./component/LoginForm";
// import ChannelBotButton from "~/common/components/ChannelBotButton";

const LoginPage = () => {
	const currentPath = "login";

	return (
		<AuthenticationLayout contentSide={true} PATH={currentPath}>
			<LoginForm />
			{/*<ChannelBotButton id={"anonymous"} />*/}
		</AuthenticationLayout>
	);
};

export default LoginPage;
